import { queryOptions, useQuery } from "@tanstack/react-query"
import type { CharacterType } from "../model/types"
import { getCharacterLastMessage } from "./client"
import { characterKeys } from "./keys"

export function characterLastMessageQueryOptions(
	character: CharacterType,
	userId: number,
) {
	return queryOptions({
		queryKey: characterKeys.lastMessage(character, userId),
		queryFn: () => getCharacterLastMessage(character, userId),
	})
}

export function useCharacterLastMessage(
	character: CharacterType,
	userId: number,
) {
	return useQuery({
		...characterLastMessageQueryOptions(character, userId),
		select: (data) => data.last_message?.trim() ?? null,
	})
}
